import React, { useEffect, useState } from "react";
import { format, parseISO } from "date-fns";
import { it } from "date-fns/locale";
import { Calendar } from "@/components/ui/calendar";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { CalendarCheck } from "lucide-react";

export function AvailabilityManager() {
  const { user, refresh } = useAuth();
  const [days, setDays] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const today = format(new Date(), "yyyy-MM-dd");
    setDays((user?.availabilityCalendar || []).filter((d) => d >= today).map((d) => parseISO(d)));
  }, [user]);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/me/availability", { dates: days.map((d) => format(d, "yyyy-MM-dd")) });
      toast.success("Calendario disponibilità aggiornato");
      refresh();
    } catch (e) { toast.error(e?.response?.data?.detail || "Salvataggio non riuscito"); }
    finally { setSaving(false); }
  };

  return (
    <div className="mt-8 card-premium p-6" data-testid="availability-manager">
      <div className="flex items-center gap-2 mb-2"><CalendarCheck className="w-5 h-5 text-gold" /><h3 className="font-display text-xl font-bold">Calendario disponibilità</h3></div>
      <p className="text-sm text-slate-600 mb-4 max-w-2xl">Clicca solo i giorni in cui sei libero: tutti gli altri risultano pieni. Se non indichi nessuna data il tuo calendario risulta completamente pieno e non puoi essere prenotato, quindi ricordati di aggiornarlo ogni mese. Una data prenotata viene tolta automaticamente.</p>
      <div className="flex flex-col lg:flex-row gap-6">
        <div className="border border-slate-200 rounded-2xl w-fit" data-testid="availability-calendar">
          <Calendar mode="multiple" locale={it} numberOfMonths={2} selected={days} onSelect={(d) => setDays(d || [])} disabled={{ before: new Date() }} />
        </div>
        <div className="flex-1">
          <div className="overline text-slate-500 mb-2">{days.length} date selezionate</div>
          <div className="flex flex-wrap gap-2 mb-4 max-h-48 overflow-y-auto">
            {[...days].sort((a, b) => a - b).map((d) => <span key={d.toISOString()} className="chip-navy">{format(d, "EEE d MMM", { locale: it })}</span>)}
          </div>
          <button data-testid="availability-save" disabled={saving} onClick={save} className="btn-pill-gold text-sm">{saving ? "Salvataggio…" : "Salva disponibilità"}</button>
        </div>
      </div>
    </div>
  );
}
